import { css } from "@emotion/react";

export * from "../../styles/shared";

export const maxWidth = css`
  max-width: var(--max-width);
`;